import { FieldGroup } from "@/features/automation-configuration/parts/FieldGroup";
import { Step } from "@/v2/features/sampling/Step";
import { Button, Flex, Text, TextArea } from "@radix-ui/themes";
import { useCallback } from "react";
import filterRuleDialogStyles from "./FilterRuleDialog.module.scss";

export type KnownMessagePlaceholder = {
  fieldId: string;
  label: string;
  token: string;
};

type FilterRuleMessageStepProps = {
  message: string;
  onMessageChange: (value: string) => void;
  onAppendKnownToken: (token: string) => void;
  knownPlaceholders: KnownMessagePlaceholder[];
};

export function FilterRuleMessageStep({
  message,
  onMessageChange,
  onAppendKnownToken,
  knownPlaceholders,
}: FilterRuleMessageStepProps) {
  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onMessageChange(e.target.value);
    },
    [onMessageChange]
  );

  return (
    <Step
      index={2}
      label="Message"
      description="Enter the message to send when these conditions are met"
    >
      <FieldGroup>
        <Flex direction="column" gap="4" width="100%">
          <TextArea
            value={message}
            onChange={handleTextChange}
            placeholder="Enter message text"
            rows={6}
            className={filterRuleDialogStyles.messageTextArea}
          />
          {knownPlaceholders.length > 0 ? (
            <Flex direction="column" gap="2" width="100%">
              <Text size="1" color="gray">
                Context placeholders (click to append to the message):
              </Text>
              <Flex
                gap="2"
                align="center"
                className={filterRuleDialogStyles.knownPlaceholders}
              >
                {knownPlaceholders.map((placeholder) => (
                  <Button
                    key={placeholder.fieldId}
                    type="button"
                    variant="soft"
                    color="gray"
                    size="1"
                    highContrast
                    className={filterRuleDialogStyles.knownPlaceholderButton}
                    onClick={() => onAppendKnownToken(placeholder.token)}
                  >
                    <Text size="1">{placeholder.token}</Text>
                  </Button>
                ))}
              </Flex>
            </Flex>
          ) : null}
        </Flex>
      </FieldGroup>
    </Step>
  );
}
